import { useQuery } from '@tanstack/react-query';
import { fetchNotifications } from '../services/notificationService';

export function useNotifications({ page = 1, unreadOnly = false } = {}) {
  return useQuery({
    queryKey: ['notifications', { page, unreadOnly }],
    queryFn: () => fetchNotifications({ page, unreadOnly }),
    staleTime: 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}
